module.exports = __webpack_public_path__ + "img/login-side-image.1cea0318.svg";